// Feature flags controlate la momentul build-ului.
// Default: toate functiile active (productia Amel ramane neschimbata).
// REACT_APP_HIDE_SCANX=true (setat DOAR la build-ul demo Wood/Yvola) ascunde
// complet functia ScanX din interfata: pagina /scan-x, tabul din Bun venit,
// taburile sursa ScanX din Docu-P / Documente / BI / Oferte Admin si linkurile
// ScanX din Configurator si Obloane. Nu afecteaza grupul de permisiuni "scan-x".
export const HIDE_SCANX = process.env.REACT_APP_HIDE_SCANX === 'true';

// REACT_APP_HIDE_OBLOANE=true (setat DOAR la build-ul demo PVC) ascunde complet
// modulul Obloane din interfata: intrarile de meniu Obloane, rutele /obloane* si
// /calcul-simplificat-obloane si /obloane-lemn (redirect la /welcome) si cardurile
// Obloane din Bun venit. Nu afecteaza grupul de permisiuni "scan-x".
export const HIDE_OBLOANE = process.env.REACT_APP_HIDE_OBLOANE === 'true';

// REACT_APP_WELCOME_VARIANT selecteaza o varianta de pagina de bun venit.
// Gol (default) = pagina standard Amel/Wood. "pvc" = varianta TAMPLARIE PVC
// (titlu PVC + butoane de sistem profil care deschid configuratorul).
export const WELCOME_VARIANT = process.env.REACT_APP_WELCOME_VARIANT || '';

// REACT_APP_HIDE_ESENTA_LEMN=true (setat DOAR la build-ul demo PVC) ascunde
// afisarea esentei de lemn (pin, stejar, meranti etc) din interfata: selectoare,
// coloane si randuri Esenta. Notiunea de esenta lemn nu se aplica la PVC.
// Valoarea din date (esenta_lemn) ramane neschimbata pentru motorul de pret.
export const HIDE_ESENTA_LEMN = process.env.REACT_APP_HIDE_ESENTA_LEMN === 'true';
